import BrandStudyMethods from "./requestMethods/brandStudy";

export const APIServiceRequestMethods = {
  // Brand Study Request Methods
  getBrandStudyById: BrandStudyMethods.getBrandStudyById,
};
